import $ from 'jquery'
import Cookies from 'js-cookie'

import { getI18nText } from '~/src_old/shared/utils/translate'

import { reloadPage } from '@backoffice/utils/helpers/util.helpers'
import Api from '@cookieManage/services/Api'
import CookiesManager from '@cookieManage/services/CookiesManager'

export function jqCookieManageWidgetForm() {
  $(document).ready(() => {
    const hasCookiePermission = Cookies.get('cookie_permission')
    const cookieSettings = CookiesManager.getCookieSettings()
    const switchElements = $(
      'div[id=performance-switch], div[id=advertising-switch], div[id=support-switch]'
    )
    const inputElements = $('input[id=performance], input[id=advertising], input[id=support]')

    const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 801
    const submitButton = isDesktop
      ? $('#submit-cookie-data-btn-desktop')
      : $('#submit-cookie-data-btn-mobile')

    inputElements.prop('checked', function () {
      const id = $(this).prop('id')
      if (hasCookiePermission && cookieSettings) return cookieSettings[id]
      return false
    })

    inputElements.attr('data-init-value', function () {
      return $(this).prop('checked')
    })

    toggleVisibleSupportNote()

    switchElements.on('click', function () {
      $(this)
        .find('input[type=checkbox]')
        .prop('checked', (idx, value) => !value)

      const isDirty = Array.from(inputElements).some((element) => {
        const currentInput = element as HTMLInputElement
        const initValue = JSON.parse(currentInput.getAttribute('data-init-value') as string)
        return currentInput.checked !== initValue
      })

      if (isDirty) {
        submitButton.show()
      } else {
        submitButton.hide()
      }

      toggleVisibleSupportNote()
    })

    submitButton.click(async (e) => {
      const hasCookiePermission = Cookies.get('cookie_permission')
      const data = {
        performance: false,
        advertising: false,
        support: false,
      }

      inputElements.each((idx, elem) => {
        const id = $(elem).prop('id')
        const checked = $(elem).prop('checked')
        data[id] = checked

        $(elem).attr('data-init-value', () => checked)
      })

      if (!hasCookiePermission) await Api.updateCookiePermission()

      CookiesManager.setCookies(data)
      triggerSubmitFeedback($(e.target))

      reloadPage()
    })
  })
}

const toggleVisibleSupportNote = () => {
  const clarificationNote = $('#clarification-note')
  const supportCookieChecked = $('input[id=support]').prop('checked')

  if (supportCookieChecked) {
    clarificationNote.hide()
  } else {
    clarificationNote.show()
  }
}

const triggerSubmitFeedback = (btn: JQuery<HTMLElement>) => {
  btn.attr('data-loading', 'false').text('')
  btn.addClass('saved').text(getI18nText({ id: 'action.saved' }))

  setTimeout(() => {
    btn
      .attr('data-loading', 'false')
      .addClass('saved')
      .text(getI18nText({ id: 'action.saved' }))

    setTimeout(() => {
      btn
        .removeClass('saved')
        .text(getI18nText({ id: 'public.cookie_manage.modal.apply_btn' }))
        .removeAttr('data-loading')
        .hide()
    }, 1000)
  }, 500)
}
